import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { db } from './firebase';
import { onSnapshot, doc, getDoc } from 'firebase/firestore';

const Background = styled.div`
  background: #295A30;
  width: 100vw;
  height: 50px;
  border-radius: 50px;
  overflow: hidden;
`;

const Foreground = styled.div<{ max: number, value: number }>`
  background: url(${process.env.PUBLIC_URL + "assets/images/T_ProgressBar.png"});
  background-size: auto 400%;
  border-radius: 50px;
  width: ${props => (props.value / props.max) * 100}%;
  height: 100%;
  transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);
`;
const Title = styled.h3`
  text-align:center;
  color: #f2cc5b;
  font-size: 20px;
  font-weight:400;
  font-family: 'Gotham',sans-serif;
  padding-bottom:20px;
@media only screen and (min-width: 768px) {
  font-size: 30px;
  padding-bottom:30px;
}
  `;



const ProgressBar: React.FC<{ max: number, value: number }> = (props) => {
  return (
    <Background>
      <Foreground max={props.max} value={props.value} />
    </Background>
  )
}

function App() {
  const [value, setValue] = useState('0');
  const [valueInt, setValueInt] = useState(0);
  const [nextTarget, setNextTarget] = useState('0');
  const [max, setMax] = useState(0);

  const getProgression = useCallback(async () => {
    const configRef = doc(db, "system", "config");
    const configSnap = await getDoc(configRef);

    onSnapshot(doc(db, "jackpots", (configSnap.data() as any).currentJackpot), (doc) => {
      //console.log("Current data:", doc.data());
     setValueInt((doc.data() as any).points);
      setValue(valueInt.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 "));
      setMax((doc.data() as any).maxTarget);
      const targets = (doc.data() as any).targets
            if (valueInt < targets[0].percentage * max) {
                const nextT=(targets[0].percentage * max).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
                setNextTarget(nextT)
            } else if (valueInt < targets[1].percentage * max) {
              const nextT=(targets[1].percentage * max).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
              setNextTarget(nextT)
          }else if (valueInt < targets[2].percentage * max) {
            const nextT=(targets[2].percentage * max).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
            setNextTarget(nextT)
        } else if (valueInt < targets[3].percentage * max) {
          const nextT=(targets[3].percentage * max).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
          setNextTarget(nextT)
      } else {
          setNextTarget('200 000')
      }
    });
  }, [max, valueInt]);

  useEffect(() => {
    getProgression();
  });

  return (
    <>
    <Title>Déjà <strong>{value} abeilles</strong> parrainées ! <br/>Prochain palier : <strong>{nextTarget} abeilles</strong></Title>
    <ProgressBar max={max} value={valueInt} />
    </>
  );
}

export default App;
